import { createSlice } from '@reduxjs/toolkit'
import {
  getOrderDeleteRequests,
  saveOrderDeleteRequest,
  createOrderDeleteRequest,
  deleteOrderDeleteRequest,
} from './orderDeleteRequestActions'

const initialState = {
  orderDeleteRequests: [],
  loading: false,
  error: false,
  loaded: false,
  saving: false,
  saved: false,
  savedOrderDeleteRequest: {},
  deleting: false,
  deleted: false,
}

/*function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}*/

const orderDeleteRequestsSlice = createSlice({
  name: 'orderDeleteRequests',
  initialState,
  reducers: {
    clear: (state) => {
      state.loading = false
      state.loaded = false

      state.saving = false
      state.error = false
      state.saved = false
      state.savedOrderDeleteRequest = {}

      state.deleting = false
      state.deleted = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getOrderDeleteRequests.fulfilled, (state, { payload }) => {
        state.loading = false
        state.loaded = true
        state.error = null
        state.orderDeleteRequests = payload
      })
      .addCase(getOrderDeleteRequests.pending, (state) => {
        state.loading = true
        state.loaded = false
        state.error = null
      })
      .addCase(getOrderDeleteRequests.rejected, (state, { payload }) => {
        state.loading = false
        state.loaded = false
        state.error = payload
      })
      .addCase(saveOrderDeleteRequest.pending, (state) => {
        state.saving = true
        state.error = null
        state.saved = false
      })
      .addCase(saveOrderDeleteRequest.fulfilled, (state, { payload }) => {
        state.error = null
        state.orderDeleteRequests[state.orderDeleteRequests.findIndex((p) => p.id === payload.id)] =
          payload
        state.savedOrderDeleteRequest = payload
        state.saved = true
        state.saving = false
      })
      .addCase(saveOrderDeleteRequest.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.saved = false
      })
      .addCase(createOrderDeleteRequest.pending, (state) => {
        state.saving = true
        state.error = null
        state.saved = false
      })
      .addCase(createOrderDeleteRequest.fulfilled, (state, { payload }) => {
        state.error = null
        state.savedOrderDeleteRequest = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createOrderDeleteRequest.rejected, (state, { payload }) => {
        state.saving = false
        state.error = payload
        state.saved = false
      })
      .addCase(deleteOrderDeleteRequest.pending, (state) => {
        state.deleting = true
        state.error = null
        state.deleted = false
      })
      .addCase(deleteOrderDeleteRequest.fulfilled, (state) => {
        state.error = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deleteOrderDeleteRequest.rejected, (state, { payload }) => {
        state.deleting = false
        state.error = payload
        state.deleted = false
      })
  },
})

export const { clear } = orderDeleteRequestsSlice.actions
export default orderDeleteRequestsSlice.reducer
